export enum FeatureKey {
  SystemNotifications = 'SystemNotifications',
  NotificationSettings = 'NotificationSettings',
  YourAccount = 'YourAccount',
  YourPreferences = 'YourPreferences',
  ShiftSettings = 'ShiftSettings',

  // menu/bar/all keys
  Home = 'crm:home',
  OFManager = 'crm:of',
  NewPost = 'crm:of:post',
  Posts = 'crm:of:posts',
  Notifications = 'crm:of:notifications',
  Messages = 'crm:of:messages',
  MessagesPro = 'crm:of:messagespro',
  Vault = 'crm:of:vault',
  Queue = 'crm:of:queue',
  Collections = 'crm:of:collections',
  Statements = 'crm:of:statements',
  Statistics = 'crm:of:statistics',
  MyProfile = 'crm:of:profile',
  OFSettings = 'crm:of:settings',
  Analytics = 'crm:analytics',
  CreatorReports = 'crm:analytics:creator',
  AnalyticsCreatorOverview = 'crm:analytics:creator:overview',
  CreatorsPerformance = 'crm:analytics:creator:performance',
  ChatterReports = 'crm:analytics:chatter',
  FanProfilingReports = 'crm:analytics:fanProfiling',
  AnalyticsFanProfilingOverview = 'crm:analytics:fanProfiling:overview',
  ChatterReportsOverview = 'crm:analytics:chatter:overview',
  ChattersPerformance = 'crm:analytics:chatter:performance',
  FansReports = 'crm:analytics:fansR',
  Growth = 'crm:growth',
  SmartTags = 'crm:growth:tags',
  AutoFollow = 'crm:growth:follow',
  Scripts = 'crm:growth:scripts',
  ProfilePromotion = 'crm:growth:profile',
  FreeTrialLinks = 'crm:growth:trialLinks',
  TrackingLinks = 'crm:growth:trackingLinks',
  TrackingLinkDetails = 'crm:growth:trackingLinks:detail',
  SensitiveWords = 'crm:growth:sensitiveWords',
  ShareForShare = 'crm:share',
  DiscoverCreators = 'crm:share:discover',
  RequestLink = 'crm:share:requestLink',
  Request = 'crm:share:request',
  S4SSchedule = 'crm:share:s4sSchedule',
  S4SSettings = 'crm:share:s4sSettings',
  Creators = 'crm:creators',
  ManageCreators = 'crm:creators:manage',
  Employees = 'crm:employees',
  ManageEmployees = 'crm:employees:manage',
  ShiftSchedule = 'crm:shift',
  ShiftsScheduling = 'crm:shift:schedule',
  ShiftsRecords = 'crm:shift:records',
  Affiliates = 'crm:affiliates',
  Settings = 'crm:settings',
  Billing = 'crm:settings:billing',
  Wallet = 'crm:settings:wallet',
  SalesSettings = 'crm:settings:sales',
  RoleSettings = 'crm:settings:role',
  MaintenanceCreator = 'crm:maintenance:creator',
  MaintenanceProxy = 'crm:maintenance:proxy',
  MaintenanceCrawler = 'crm:maintenance:crawler',
  Maintenance = 'crm:maintenance',
}

export function getFeatureKeysObject<T>(value: T): Record<FeatureKey, T> {
  return Object.values(FeatureKey).reduce(
    (result, featureKey) => ({ ...result, [featureKey]: value }),
    {} as Record<FeatureKey, T>,
  )
}
